import {
  rearrangeOnDraggingBetweenElements,
  rearrangeOnDraggingAtEndOfElements,
} from '../rearrangeCards';

export default (params) => {
  const { afterRole, editor, currentNodeKey, dragType } = params;

  const {
    value: { document: editorDocument },
  } = editor;
  let nextEmptyParaKey;

  if (dragType !== 'ARRAY_ITEM')
    ({ key: nextEmptyParaKey } = editorDocument.getNextNode(currentNodeKey));

  const parent = editorDocument;
  if (afterRole) {
    const afterRoleKey = afterRole.getAttribute('data-key');
    const afterRoleNode = editorDocument.getNode(afterRoleKey);
    rearrangeOnDraggingBetweenElements({
      editor,
      parent,
      afterRoleNode,
      currentNodeKey,
      nextEmptyParaKey,
      dragType,
    });
  } else {
    const {
      nodes: { size: nodesSize },
    } = parent;
    rearrangeOnDraggingAtEndOfElements({
      editor,
      currentNodeKey,
      parent,
      newIndex: nodesSize,
      nextEmptyParaKey,
      dragType,
    });
  }
};
